<template>
  <div class="uk-margin">
      <div class="form-group">
          <label class="uk-form-label" :for="name">{{ label }}</label>
          <input
            :type="type"
            ref="input"
            class="form-control"
            :name="name"
            :id="name"
            :placeholder="placeholder"
            :value="text"
            :disabled="disabled"
            @input="emitChange">
      </div>
  </div>
</template>

<script>
export default {
  name: 'ElementInput',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      default: '',
    },

    text: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: 'text',
      required: true,
    },
  },
  methods: {
    emitChange() {
      let isValid = true;
      const value = this.$refs.input ? this.$refs.input.value : '';
      if (this.type === 'email') {
        isValid = this.validEmail(value);
      }
      this.$emit('change', {
        key: this.name,
        data: value,
        isValid: !!value.length && isValid,
      });
    },

    validEmail(email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>
